module.exports = __webpack_public_path__ + "sygnet.c8d5c2d9.svg";